import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TerminalAdminComponent } from './terminal-admin/terminal-admin.component';
import { AppPropertiesService, AppPropertyComponentsModule, CommonLayoutModule, CommonUIModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TerminalAdminComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    AppPropertyComponentsModule,
    CommonUIModule
]
})
export class TerminalAdminModule {

constructor(
  private appPropertiesService: AppPropertiesService
) {
  appPropertiesService.registerAppPropertiesAdminComponent('tmc-yard.terminal.ui.terminal-properties-admin.tab-title', TerminalAdminComponent);
}

}
